import LoginForm from './components/Login/LoginForm';
import ForgotPasswordForm from './components/ForgotPassword/ForgotPasswordForm';
import CreateAccountForm from '../../modules/contact/CreateAccountForm';
import ResetPasswordForm from './components/ResetPassword/ResetPasswordForm';
import StyleForm from './hooks/StyleForm';

const Auth = (vm) => {
  const props = StyleForm({authView: vm.authView})
  return (
    <main
      className={`
        w-full min-h-[100dvh] login-topographic-bg
        ${props.isCenterView ? 'flex items-center justify-center' : ''}
        ${props.isCreateAccount && props.shouldCenterCreate ? 'flex items-center justify-center' : ''}
      `}
    >
      <div
        ref={props.contentRef} className={`
          w-full mx-auto
          ${props.isLoginView ? 'max-w-none px-0 py-0' : 'max-w-4xl px-4 py-6 sm:py-8'}
        `}
      >
        {vm.authView === 'login' && (
          <LoginForm
            onLogin={vm.handleLogin}
            onForgotPassword={() => vm.setAuthView('forgotPassword')}
            onCreateAccount={() => vm.setAuthView('createAccount')}
            message={vm.updateMessage}
          />
        )}
        {vm.authView === 'forgotPassword' && (
          <ForgotPasswordForm
            onBackToLogin={() => vm.setAuthView('login')}
            logout={vm.expireSesion}
            message={vm.updateMessage}
          />
        )}
        {vm.authView === 'createAccount' && (
          <CreateAccountForm
            onBackToLogin={() => vm.setAuthView('login')}
            mode="create"
            userlogin={null}
            permissions={vm.permission}
            logout={vm.expireSesion}
            losesAccess={vm.losesAccess}
            message={vm.updateMessage}
          />
        )}
        {vm.authView === 'resetPassword' && (
          <ResetPasswordForm
            onBackToLogin={() => vm.setAuthView('login')}
            code={vm.resetCode}
            logout={vm.expireSesion}
            message={vm.updateMessage}
          />
        )}
      </div>
    </main>
  );
};

export default Auth;
